import { useAuth } from "@/_core/hooks/useAuth";
import ProposalMutationForbiddenPage from "@/components/sales/ProposalMutationForbiddenPage";
import { isProposalReadOnlyRole } from "@shared/proposalOperationalAccess";
import type { ComponentType } from "react";

/**
 * Wrap create/edit/revise/VO workspace routes so Inventory/Procurement never
 * see an editable form — even via deep link.
 */
export function withProposalMutationRouteGuard<P extends object>(
  Page: ComponentType<P>,
  options?: { title?: string; description?: string },
): ComponentType<P> {
  function Guarded(props: P) {
    const { user, loading } = useAuth();
    if (loading) return null;
    if (isProposalReadOnlyRole(user?.role)) {
      return (
        <ProposalMutationForbiddenPage
          title={options?.title ?? "Read-only access"}
          description={
            options?.description ??
            "Your Inventory / Procurement role can view proposals but cannot create, edit, revise, or send them."
          }
        />
      );
    }
    return <Page {...props} />;
  }
  Guarded.displayName = `WithProposalMutationRouteGuard(${Page.displayName || Page.name || "Page"})`;
  return Guarded;
}
